import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TBillingState } from "./Billing.interfaces";
//import { toastr } from "react-redux-toastr";

const initialState: TBillingState = {
    payOption: '',
    companyName: '',
    invoiceNumber: '',
    invoiceDate: new Date().toISOString()
}

export const BillingSlice = createSlice({
    name: 'billing',
    reducers: {
        setInvoice: (state, action: PayloadAction<TBillingState>) => {
            state.companyName = action.payload.companyName;
            state.invoiceDate = action.payload.invoiceDate;
            state.invoiceNumber = action.payload.invoiceNumber;
            state.payOption = action.payload.payOption;
        }
    },
    initialState
})

export const {
    setInvoice
} = BillingSlice.actions

export default BillingSlice.reducer;